require("./style.css");
import React from "react";
import AcquireWebComponent from "../../framework/MaterialUI";
import PieChartTable from "../distribution/PieChartTable";
import LineGraphicSection from "../LineGraphic";
import { splitNumber, timezonLabel } from "../../../utils/utility";
import isUndefined from "lodash/isUndefined";
import { Link } from "react-router-dom";
import HeatMap from "../HeatMap";
import ListGraphicSection from "../ListGraphic";
import ListGraphicV2 from "./ListGraphic";
const google = window.google;

class OverviewInsights extends AcquireWebComponent {
  businessOverview(totalVisitsCount, uniqueVisitsCount, reachSum) {
    return (
      <div className="light-grey-border">
        <div className="mt-20 ml-20" style={{ height: "16px" }}>
          <p style={{ fontSize: "24px", height: "16px", fontWeight: "bold" }}>
            Domestic Business Information
          </p>
        </div>
        <div
          className="no-margin-bottom pt-20 pb-20 mt-20"
          style={{ fontWeight: "300", display: "flex" }}
        >
          <div
            style={{
              flex: "1 1",
              paddingLeft: "20px",
            }}
          >
            <div
              style={{
                color: "#000",
                marginTop: "20px",
                marginRight: "20px",
                textAlign: "left",
              }}
            >
              Total Visits
            </div>
            <div
              style={{
                fontSize: "60px",
                fontWeight: "normal",
                color: "#32A59D",
                paddingRight: "20px",
                textAlign: "left",
              }}
            >
              {splitNumber(totalVisitsCount + "")()}
            </div>
          </div>
          <div
            className="pr-10 pl-20 light-grey-left-border"
            style={{
              width: "40%",
              display: "flex",
              alignItems: "center",
            }}
          >
            {/*
            <div className="pl-20 pr-20 pb-20">
              We can reach at least &nbsp;
              <strong>
                {reachSum ? splitNumber(reachSum.total + "")() : 0}
              </strong>
              &nbsp; of these unique business
          </div>*/}
            <div
              style={{
                width: "100%",
                textAlign: "left",
                padding: "20px",
                lineHeight: "18px",
                marginBottom: "10px",
              }}
            >
              We can reach at least{" "}
              <strong>
                {reachSum ? splitNumber(reachSum.total + "")() : 0}
              </strong>{" "}
              of these unique business
              {/*<ServiceContact
                className="no-padding"
                sendAssistRequest={this.props.sendAssistRequest}
                style={{
                  fontSize: "16px",
                  textAlign: "left",
                  fontWeight: "normal",
                }}
                send_assist_request_error={this.props.send_assist_request_error}
                request_assist_successful={this.props.request_assist_successful}
                selected_client={this.props.selected_client}
                pageSource={this.props.pageSource}
              />{" "}*/}
            </div>
          </div>
          <div
            className="ml-10 light-grey-left-border pl-20 pt-5"
            style={{
              justifyContent: "flex-end",
              flex: "1 1",
            }}
          >
            <div
              style={{
                color: "#000",
                marginTop: "20px",
                marginRight: "20px",
                textAlign: "left",
              }}
            >
              Unique Visits
            </div>
            <div
              style={{
                fontSize: "60px",
                fontWeight: "normal",
                marginTop: "-3px",
                color: "#32A59D",
                marginRight: "20px",
                textAlign: "left",
              }}
            >
              {splitNumber(uniqueVisitsCount + "")()}
            </div>
          </div>
        </div>
      </div>
    );
  }
  render() {
    const {
      visitsByTime,
      geoTrafficeData = [],
      timeTraffic,
      timeTrafficStatsTitle,
      visitsSummary,
      selected_client,
      kindOfReport,
      statsByRegionalTraffic,
      heatMapData,
      loadingStatsByRegionalTraffic,
      reportType,
      deviceTypeData,
      demoData,
      popUrl,
      statsByPopularPages,
      pdfCreating,
    } = this.props;
    const randomStr = new Date().getTime();

    if (kindOfReport === "map") {
      return (
        <div className="p-20 light-grey-border">
          <HeatMap
            key={"overview-geographic-" + randomStr}
            width={960}
            height={600}
            title="Geographic Traffic"
            data={statsByRegionalTraffic}
            onLoading={loadingStatsByRegionalTraffic}
            pointsData={heatMapData}
          />
        </div>
      );
    }
    if (isUndefined(visitsSummary)) {
      return (
        <div
          className="overview-insights-container"
          style={{ fontSize: "16px" }}
        >
          <div
            style={{
              float: "left",
              height: "200px",
              width: "100%",
              position: "relative",
              padding: "20px",
            }}
          >
            <img alt="" src="/Spinner.gif" style={{ height: "24px" }} />
            &nbsp;loading...
          </div>
        </div>
      );
    }
    const { reachStats, totalVisitsCount, uniqueVisitsCount } = visitsSummary;
    return (
      <div id="overview-container-box">
        {reportType === "business" ? (
          this.businessOverview(totalVisitsCount, uniqueVisitsCount, reachStats)
        ) : (
          <div
            className="mt-20 p-20 light-grey-border"
            id="consumer-overflow-pdf-part2"
          >
            <div style={{ fontSize: "24px", fontWeight: "bold" }}>Overview</div>
            <div className="mt-20" style={{ display: "flex" }}>
              <div
                  style={{width: '100%'}}
                className="light-grey-right-border"
              >
                <div style={{ textAlign: "center" }}>Total Visits</div>
                <div
                  className="light-grey-bottom-border"
                  style={{
                    fontSize: "64px",
                    color: "#32A59D",
                    textAlign: "center",
                  }}
                >
                  {splitNumber(totalVisitsCount + "")()}
                </div>
                <div className="mt-20" style={{ textAlign: "center" }}>
                  Unique Visits
                </div>
                <div
                  className="pb-20"
                  style={{
                    fontSize: "64px",
                    color: "#32A59D",
                    textAlign: "center",
                  }}
                >
                  {splitNumber(uniqueVisitsCount + "")()}
                </div>
              </div>
            </div>
          </div>
        )}
        {reportType === "business" && (
          <div className="mt-20 light-grey-border" key="1">
            <div style={{ padding: "20px" }}>
              <ListGraphicSection
                title={"Business Firmographic"}
                mode="business"
                data={demoData}
                key={"demographic-section-2"}
                footer={
                  this.props.popUrl || pdfCreating ? (
                    undefined
                  ) : (
                    <Link
                      to={"/insights/business?nav=fir&cid=" + selected_client}
                    >
                      View Frequent Visitors
                    </Link>
                  )
                }
              />
            </div>
            <div>
              <div className="pb-10">
                {geoTrafficeData && (
                  <PieChartTable
                    data={geoTrafficeData}
                    showUniqVisitsTitle={true}
                    dataKey="value"
                    title={"Geographic Traffic"}
                    tableTitle="States"
                    inLine={true}
                    footer={
                      !pdfCreating &&
                      !this.props.popUrl && (
                        <div style={{ padding: "15px 0 5px 30px" }}>
                          <Link
                            to={
                              this.props.reportType +
                              "/map?cid=" +
                              selected_client
                            }
                          >
                            View on a Map
                          </Link>
                        </div>
                      )
                    }
                  />
                )}
              </div>
            </div>
          </div>
        )}
        <div
          className="mt-20"
          id="consumer-overflow-pdf-part3"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <div style={{ width: "49%" }}>
            <div className="light-grey-border">
              {visitsByTime && (
                <PieChartTable
                  data={visitsByTime}
                  showUniqVisitsTitle={true}
                  dataKey="value"
                  title={"Visits by Time of Day"}
                  tableTitle={"Time of Day"}
                />
              )}
            </div>
          </div>
          <div style={{ width: "49%" }}>
            <div className="light-grey-border">
              {reportType === "business"
                ? deviceTypeData && (
                    <PieChartTable
                      data={deviceTypeData.values}
                      showUniqVisitsTitle={true}
                      dataKey="value"
                      title="Device"
                      tableTitle={deviceTypeData.name}
                    />
                  )
                : geoTrafficeData && [
                    <PieChartTable
                      key="11"
                      data={geoTrafficeData}
                      showUniqVisitsTitle={true}
                      dataKey="value"
                      title={"Geographic Traffic"}
                      tableTitle="States"
                    />,
                    geoTrafficeData &&
                      geoTrafficeData.length > 0 &&
                      !pdfCreating &&
                      !this.props.popUrl && (
                        <div key="12" className="mb-20">
                          <Link
                            className="ml-20"
                            to={
                              this.props.reportType +
                              "/map?cid=" +
                              selected_client
                            }
                          >
                            View on a Map
                          </Link>
                        </div>
                      ),
                  ]}
            </div>
          </div>
        </div>
        <div
          className="p-20 mt-20 light-grey-border"
          id="consumer-overflow-pdf-part4"
        >
          <LineGraphicSection
            animation={false}
            key={"time-traffic-section"}
            title={reportType === "business" ? "Traffic" : "Consumer Traffic"}
            data={timeTraffic}
            type={reportType}
            subTitle={
              timeTrafficStatsTitle +
              " - " +
              timezonLabel(this.props.client_info.timezone)
            }
          />
        </div>
        {reportType === "business" && !popUrl && (
          <div className="mt-20">
            <div
              className="light-grey-border p-20"
              style={{ display: "inline-block", minWidth: "50%" }}
            >
              {statsByPopularPages && (
                <ListGraphicV2
                  title={"Most Popular Pages"}
                  data={statsByPopularPages}
                  key={"demographic-section-pop-pages"}
                  subTitle={"Unique Visits"}
                  footer={
                    pdfCreating ? null : (
                      <div className="pt-20 light-grey-top-border">
                        <Link
                          to={
                            "/insights/business?cid=" +
                            this.props.selected_client +
                            "&nav=pop"
                          }
                        >
                          View More Page Information
                        </Link>
                      </div>
                    )
                  }
                />
              )}
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default OverviewInsights;



// WEBPACK FOOTER //
// ./src/components/Insights/website/OverviewInsights.jsx